/**
 * Light document layout for privacy / terms / help. Internal to the auth
 * feature. Imports auth-pages.css via AuthLayout's module graph; imported
 * here too so this file stands alone.
 */
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { BackIcon } from '@/components/icons'
import { PATHS } from '@/app/router/paths'
import './auth-pages.css'

export function DocLayout({ title, updated, children }: { title: string; updated?: string; children: ReactNode }) {
  return (
    <main className="auth-doc">
      <div className="auth-doc-inner">
        <div>
          <Link
            to={PATHS.welcome}
            aria-label="Terug naar start"
            style={{
              width: 44,
              height: 44,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'var(--text-secondary)',
              marginLeft: -12,
            }}
          >
            <BackIcon size={24} />
          </Link>
        </div>
        <h1>{title}</h1>
        {updated && <time>{updated}</time>}
        {children}
        <nav className="auth-footer-legal" aria-label="Meer informatie" style={{ marginTop: 24 }}>
          <Link to={PATHS.legal.privacy} style={{ color: 'var(--soft-blue)' }}>
            Privacy
          </Link>
          <Link to={PATHS.legal.terms} style={{ color: 'var(--soft-blue)' }}>
            Voorwaarden
          </Link>
          <Link to={PATHS.legal.help} style={{ color: 'var(--soft-blue)' }}>
            Hulp
          </Link>
        </nav>
      </div>
    </main>
  )
}
